var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmergency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emergency",
    transform: "translate(-389 -612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 72,
    height: 72,
    rx: 12,
    transform: "translate(389 612)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "emergency_icon",
    "data-name": "emergency icon",
    transform: "translate(407.923 630.923)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 48,
    height: 48,
    transform: "translate(-6.923 -6.923)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    d: "M12.62,1.728A10.9,10.9,0,0,0,1.728,12.62V19H23.512V12.62A10.9,10.9,0,0,0,12.62,1.728M12.62,0a12.62,12.62,0,0,1,12.62,12.62v8.113H0V12.62A12.62,12.62,0,0,1,12.62,0Z",
    transform: "translate(4.251 7.368)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    d: "M3.606,1.728a1.878,1.878,0,1,0,0,3.756H29.747a1.878,1.878,0,1,0,0-3.756H3.606M3.606,0H29.747a3.606,3.606,0,0,1,0,7.211H3.606A3.606,3.606,0,1,1,3.606,0Z",
    transform: "translate(-0.256 27.199)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M-1497.047,2809.18h-.025a.861.861,0,0,1-.839-.882,8.386,8.386,0,0,1,.83-3.2,5.78,5.78,0,0,1,5.526-3.318.865.865,0,0,1,.863.865.863.863,0,0,1-.863.863c-4.426,0-4.623,4.636-4.629,4.834A.865.865,0,0,1-1497.047,2809.18Z",
    transform: "translate(1506.874 -2790.448)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_37",
    "data-name": "Line 37",
    d: "M4.561,5.425a.861.861,0,0,1-.611-.253L-.5.725A.864.864,0,0,1,.725-.5L5.172,3.95a.864.864,0,0,1-.611,1.475Z",
    transform: "translate(4.076 3.162)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_38",
    "data-name": "Line 38",
    d: "M.114,6.314A.864.864,0,0,1-.75,5.45V.114a.864.864,0,0,1,1.728,0V5.45A.864.864,0,0,1,.114,6.314Z",
    transform: "translate(16.528 0.494)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_39",
    "data-name": "Line 39",
    d: "M.114,5.425A.864.864,0,0,1-.5,3.95L3.95-.5A.864.864,0,1,1,5.172.725L.725,5.172A.861.861,0,0,1,.114,5.425Z",
    transform: "translate(24.532 3.162)",
    fill: "#19bc9c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.c6e399261332d7103e21ef70f268afe5.svg";
export { ForwardRef as ReactComponent };